(function () {
  'use strict';

  /* ------------------------------------------------------------------
   * Submit-blocker: registered on `window` in capture phase so it fires
   * BEFORE the theme's document-level capture handler. When our widget
   * is handling a multi-item add, we set a flag attribute on the form.
   * This handler blocks the native submit entirely — preventing the
   * theme's handleSubmit from firing a duplicate /cart/add.js POST.
   * ------------------------------------------------------------------ */
  window.addEventListener(
    'submit',
    function (e) {
      if (e.target && e.target.hasAttribute('data-bbo-intercepting')) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    true
  );

  function init() {
    var widgets = document.querySelectorAll('[data-bbo-addons]');
    for (var i = 0; i < widgets.length; i++) {
      if (!widgets[i].hasAttribute('data-bbo-addons-initialized')) {
        widgets[i].setAttribute('data-bbo-addons-initialized', '');
        setupWidget(widgets[i]);
      }
    }
  }

  /* ------------------------------------------------------------------
   *  Check whether any add-on has qty > 0
   * ------------------------------------------------------------------ */
  function widgetHasActiveAddons(widget) {
    var qtyInputs = widget.querySelectorAll('[data-bbo-addon-qty]');
    for (var i = 0; i < qtyInputs.length; i++) {
      if (parseInt(qtyInputs[i].value, 10) > 0) return true;
    }
    return false;
  }

  /* ------------------------------------------------------------------
   *  Stepper wiring  (called once per widget)
   * ------------------------------------------------------------------ */
  function setupSteppers(widget) {
    var cards = widget.querySelectorAll('[data-bbo-addon-card]');
    for (var i = 0; i < cards.length; i++) {
      (function (card) {
        var qtyInput = card.querySelector('[data-bbo-addon-qty]');
        var decBtn = card.querySelector('[data-bbo-addon-dec]');
        var incBtn = card.querySelector('[data-bbo-addon-inc]');
        if (!qtyInput || !decBtn || !incBtn) return;

        function updateCardState() {
          var qty = parseInt(qtyInput.value, 10) || 0;
          card.setAttribute('data-bbo-addon-active', qty > 0 ? 'true' : 'false');
          decBtn.disabled = qty <= 0;
        }

        decBtn.addEventListener('click', function () {
          var current = parseInt(qtyInput.value, 10) || 0;
          if (current > 0) {
            qtyInput.value = current - 1;
            updateCardState();
          }
        });

        incBtn.addEventListener('click', function () {
          var current = parseInt(qtyInput.value, 10) || 0;
          var max = parseInt(qtyInput.getAttribute('max'), 10) || 10;
          if (current < max) {
            qtyInput.value = current + 1;
            updateCardState();
          }
        });

        updateCardState();
      })(cards[i]);
    }
  }

  /* ------------------------------------------------------------------
   *  Per-widget setup
   * ------------------------------------------------------------------ */
  function setupWidget(widget) {
    var section = widget.closest('.shopify-section');
    if (!section) return;

    var form = section.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    var atcButton = form.querySelector('button[name="add"]');
    if (!atcButton) return;

    /* ---- wire up quantity steppers ---- */
    setupSteppers(widget);

    /* ------------------------------------------------------------------
     * Set intercepting flag BEFORE the click event fires.
     * mousedown / touchstart / keydown all fire before click,
     * so the flag is in place when the theme's document-level
     * capture click handler runs (if it triggers a form submit).
     * ------------------------------------------------------------------ */
    function markIntercepting() {
      if (widgetHasActiveAddons(widget)) {
        form.setAttribute('data-bbo-intercepting', '');
      }
    }

    atcButton.addEventListener('mousedown', markIntercepting, true);
    atcButton.addEventListener('touchstart', markIntercepting, { capture: true, passive: true });
    atcButton.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') markIntercepting();
    }, true);

    /* ------------------------------------------------------------------
     * Click handler — capture phase on the button.
     *
     * When add-ons are active we:
     *  1. Block the click's default action + propagation
     *  2. Disable the button (so handleSubmit bails if somehow reached)
     *  3. Fire our own multi-item /cart/add.js POST
     *  4. Re-enable the button + clear the intercepting flag afterwards
     *
     * When no add-ons are active the theme's native flow runs unchanged.
     * ------------------------------------------------------------------ */
    atcButton.addEventListener(
      'click',
      function (e) {
        if (!widgetHasActiveAddons(widget)) {
          /* Clean up the flag in case mousedown set it prematurely
             (e.g. user changed qty to 0 between mousedown and click) */
          form.removeAttribute('data-bbo-intercepting');
          return;
        }

        /* ---- validate color picker ---- */
        var colorPicker = section.querySelector('[data-bbo-color-picker]');
        if (colorPicker && !colorPicker.hasAttribute('data-bbo-preorder')) {
          var colorSelect = colorPicker.querySelector('[data-bbo-select]');
          if (colorSelect && !colorSelect.value) {
            var errorEl = colorPicker.querySelector('[data-bbo-error]');
            if (errorEl) errorEl.hidden = false;
            var trigger = colorPicker.querySelector('[data-bbo-trigger]');
            if (trigger) trigger.focus();
            else colorSelect.focus();
            e.preventDefault();
            e.stopImmediatePropagation();
            form.removeAttribute('data-bbo-intercepting');
            return;
          }
        }

        /* ---- block the native submit ---- */
        e.preventDefault();
        e.stopImmediatePropagation();

        atcButton.disabled = true;

        var variantInput = form.querySelector('input[name="id"]');
        if (!variantInput || !variantInput.value) {
          atcButton.disabled = false;
          form.removeAttribute('data-bbo-intercepting');
          return;
        }

        /* ---- build the main item ---- */
        var mainItem = {
          id: parseInt(variantInput.value, 10),
          quantity: 1
        };

        var qtyInput = form.querySelector('input[name="quantity"]');
        if (qtyInput && qtyInput.value) {
          mainItem.quantity = parseInt(qtyInput.value, 10) || 1;
        }

        var colorHidden = form.querySelector('input[name="properties[Playing Surface Color]"]');
        if (colorHidden && colorHidden.value) {
          mainItem.properties = { 'Playing Surface Color': colorHidden.value };
        }

        /* ---- build add-on items from quantity steppers ---- */
        var items = [mainItem];
        var addonQtyInputs = widget.querySelectorAll('[data-bbo-addon-qty]');
        for (var i = 0; i < addonQtyInputs.length; i++) {
          var addonQty = parseInt(addonQtyInputs[i].value, 10);
          if (addonQty > 0) {
            items.push({
              id: parseInt(addonQtyInputs[i].getAttribute('data-bbo-addon-id'), 10),
              quantity: addonQty
            });
          }
        }

        /* ---- collect section IDs for cart drawer refresh ---- */
        var sectionIds = [];
        var cartItemsComponents = document.querySelectorAll('cart-items-component');
        for (var j = 0; j < cartItemsComponents.length; j++) {
          if (cartItemsComponents[j].dataset && cartItemsComponents[j].dataset.sectionId) {
            sectionIds.push(cartItemsComponents[j].dataset.sectionId);
          }
        }

        var payload = { items: items };
        if (sectionIds.length) {
          payload.sections = sectionIds.join(',');
        }

        fetch(window.Theme ? Theme.routes.cart_add_url : '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(payload)
        })
          .then(function (res) { return res.json(); })
          .then(function (response) {
            if (response.status) {
              var errSpan = form.querySelector('.product-form-text__error');
              if (errSpan) {
                errSpan.classList.remove('hidden');
                var textNode = errSpan.childNodes[2];
                if (textNode) {
                  textNode.textContent = response.message || 'Could not add items to cart.';
                } else {
                  errSpan.appendChild(document.createTextNode(response.message || 'Could not add items to cart.'));
                }
                setTimeout(function () { errSpan.classList.add('hidden'); }, 10000);
              }
              return;
            }

            var evt = new Event('cart:update', { bubbles: true });
            evt.detail = {
              resource: {},
              sourceId: variantInput.value,
              data: {
                source: 'bbo-addons',
                itemCount: items.reduce(function (sum, it) { return sum + it.quantity; }, 0),
                productId: form.closest('product-form-component')
                  ? form.closest('product-form-component').dataset.productId
                  : '',
                sections: response.sections || {}
              }
            };
            document.dispatchEvent(evt);

            var atcComponent = form.closest('product-form-component');
            if (atcComponent) {
              var addedRegion = atcComponent.querySelector('[ref="liveRegion"]');
              if (addedRegion) addedRegion.textContent = 'Added';
            }
            atcButton.classList.add('atc-added');
            setTimeout(function () { atcButton.classList.remove('atc-added'); }, 2000);
          })
          .catch(function (err) {
            console.error('bbo-addons: add to cart failed', err);
          })
          .finally(function () {
            atcButton.disabled = false;
            form.removeAttribute('data-bbo-intercepting');
          });
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
